export enum Experiment {
  EnableServerlessForBanner = 'specs.payments.EnableServerlessForBanner',
  EnablePaypalGenericBanner = 'specs.payments.EnablePaypalGenericBanner',
}
